import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import {
  DataTable,
  Field,
  CurrencyField,
  DateTimeField,
  PaymentsDataField,
  BilledField,
  PercentageField,
} from '../../../commons/DataTable';
import { useAuth } from '../../../commons/Auth';
import CustomerTypeField from '../../../commons/DataTable/CustomerTypeField';
import CustomerVatCodeField from '../../../commons/DataTable/CustomerVatCodeField';
import FieldIafNumber from '../../../commons/DataTable/FieldIafNumber';

function InsurancesRoyaltyTable({
  dataTable,
  data,
  total = 0,
  query = {},
  onFilter,
  isLoading,
  bottomRow,
  truncateTable,
  showEmptyTableMessage,
  allowedRoles = [],
  onSelectChange,
}) {
  const [t] = useTranslation('COMMON');
  const [{ newIsAdmin }] = useAuth();
  const { offset, limit } = query;

  const onCheck = (report) => {
    if (!allowedRoles.includes('superadmin')) {
      return;
    }
    onSelectChange(report);
  };

  return (
    <DataTable
      offset={offset}
      limit={limit}
      total={total}
      dataTable={dataTable}
      data={data}
      isLoading={isLoading}
      loadingText={t('LOADING')}
      emptyText={t('NO_DATA')}
      onFilter={onFilter}
      bottomRow={bottomRow}
      showEmptyTableMessage={showEmptyTableMessage}
    >
      <Field
        title="Rami"
        source="branch"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Codice polizza"
        source="policy_code"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Etichetta polizza"
        source="insurance_code"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Referente"
        source="admin.businessName"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Codice fiscale referente"
        source="admin.taxCode"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Fornitore"
        source="supplier.businessName"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Codice fiscale fornitore"
        source="supplier.taxCode"
        visible={!truncateTable && newIsAdmin}
      />

      <Field
        title="Tipo agenzia"
        source="agencyType"
        visible={!truncateTable && newIsAdmin}
      />

      <DateTimeField
        title="Data inizio"
        source="start_date"
        format="DD/MM/YYYY"
        visible={!truncateTable && newIsAdmin}
      />
      <DateTimeField
        title="Data fine"
        source="end_date"
        format="DD/MM/YYYY"
        visible={!truncateTable && newIsAdmin}
      />
      <Field
        title="Fraz"
        source="fraz"
        visible={!truncateTable && newIsAdmin}
      />
      <CurrencyField
        title="Premio lordo"
        source="gross"
        className="txt-table-right"
      />
      <CurrencyField
        title="Premio netto"
        source="net"
        className="txt-table-right"
      />
      <CurrencyField
        title="ROY La Panoramica"
        source="shareToInvoice"
        className="txt-table-right"
      />
      <PercentageField
        title="ROY La Panoramica %"
        source="shareToInvoicePerc"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin}
      />
      <CurrencyField
        title="Profitto La Panoramica"
        source="panoramicaShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Profitto Sub Agenzia"
        source="adminShare"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin}
      />
      <PercentageField
        title="Profitto Sub Agenzia %"
        source="subAgencyPerc"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin}
      />
      <CurrencyField
        title="Profitto Sub Agenzia maturata"
        source="earnedAdminShare"
        className="txt-table-right"
      />
      <CurrencyField
        title="Diritto a Fatturare"
        source="billableAdminShare"
        className="txt-table-right"
      />
      <BilledField
        title="Invitato a Fatturare"
        className="txt-table-right"
        visible={!truncateTable && newIsAdmin}
      />
      <FieldIafNumber
        title="Numero IAF"
        className="txt-table-right"
        source="iafs.0.number"
        visible={!truncateTable && newIsAdmin}
      />
    </DataTable>
  );
}

export default withRouter(InsurancesRoyaltyTable);
